<template>
  <div class="mm-page-main">
    <div class="page-header">
      <div class="page-title">訂單管理</div>
      <div @click="pageback" class="page-back">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-back"></use>
        </svg>
      </div>
    </div>

    <div class="pagemain">
      <div class="orderbox">
        <div class="orderbox-left ">

          <div class="mm-phone320">
            <div>訂單編號: {{ordernum}}</div>
            <div class="mm-flex">
              <div>
                <el-checkbox :disabled="true" v-model="buy_status">買入</el-checkbox>
              </div>
              <div>
                <el-checkbox :disabled="true" v-model="sell_status">賣出</el-checkbox>
              </div>
              <div>
                <el-checkbox :disabled="true" v-model="order_status">已完成</el-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="order-right">
          <div class="mr-10">
            <el-button @click="opensendmessage" type="primary" class="text-white">發送消息</el-button>
            <el-dialog @closed="closesendmessage" title="發送消息" :visible.sync="sendmessage" width="95%" :append-to-body="true">
              <component @closedialog="closedialog" :ordernum="ordernum" :order_id="order_id" :is="sendmessage_component"></component>
            </el-dialog>
          </div>
          <div class="changeorderstatus">
            <div>訂單狀態：</div>
            <div class="changstatusbox" style="margin-right:15px;">
              <!-- <el-select :disabled="orderinfo.status==3||orderinfo.status==5||!(buy_status&&sell_status)" v-model="neworderstatus" placeholder="请选择"> -->
              <el-select :disabled="orderinfo.status==3||orderinfo.status==5" v-model="neworderstatus" placeholder="请选择">
                <el-option v-for="item in status_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <el-button v-if="orderinfo.status!=3&&orderinfo.status!=5" type="warning" class="pc-box" :disabled="neworderstatus==orderinfo.status" @click="saveStatus">修改進度</el-button>
            <!-- <el-button v-if="!editStatus&&orderinfo.status!=5" type="warning" class="pc-box" :disabled="neworderstatus==orderinfo.status" @click="saveStatus">修改進度</el-button> -->
          </div>
        </div>
      </div>
      <div class="mm-tabs">
        <div class="mm-tabsulbox">
          <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
          <ul :style="transform" class="mm-tabs-card" v-if="ordertype==0">
            <li @click="changetabs1(index)" v-for="(tab,index) in tabs1" :key="index" :class="{active:tabsindex == index}">{{tab}}</li>
          </ul>
          <ul :style="transform" class="mm-tabs-card" v-if="ordertype==1">
            <li @click="changetabs2(index)" v-for="(tab,index) in tabs2" :key="index" :class="{active:tabsindex == index}">{{tab}}</li>
          </ul>
          <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
        </div>

        <div class="mm-tabs-content">
          <component :order_id="order_id" :store_id="store_id" :checksell.sync="sell_status" :checkbuy.sync="buy_status" :is="tabspage"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import orderinfo from "./components/OrderInfo.vue";
import buybusienes from "./components/BuyBusienes.vue";
import sellbusienes from "./components/SellBusienes.vue";
import customerinfo from "./components/OrderCustomerinfo.vue";
import orderfiles from "./components/OrderFiles.vue";
import orderprofit from "./components/OrderProfit.vue";
import orderreview from "./components/OrderReview.vue";
import orderrecord from "./components/OrderRecord.vue";
import orderprint from "./components/OrderPrint.vue";
import remitterinfo from "./components/RemitterInfo.vue";
import sendmessage from "./components/SendMessage.vue";
export default {
  components: {
    orderinfo,
    buybusienes,
    sellbusienes,
    customerinfo,
    orderfiles,
    orderprofit,
    orderreview,
    orderrecord,
    orderprint,
    remitterinfo,
    sendmessage
  },
  data () {
    return {
      default_status: 0,
      orderinfo: {},
      order_id: 0,
      store_id: 0,
      tabsindex: 0,
      transform: '',
      transformnum: 0,
      tabs1: ['基本資料', '買入', '賣出', '兌換人資料', '文件', '合規審查', '訂單利潤', '操作記錄', '打印'],
      tabs2: ['基本資料', '買入', '賣出', '匯款人資料', '匯款信息', '文件', '合規審查', '訂單利潤', '操作記錄', '打印'],
      status_options: [{
        value: 0,
        label: '準備中 Pending'
      },
      {
        value: 1,
        label: '已審核 Approved'
      },
      {
        value: 2,
        label: '處理中 Processing'
      },
      {
        value: 3,
        label: '已完成 Successful'
      },
      {
        value: 4,
        label: '失敗 Fail'
      },
      {
        value: 5,
        label: '已刪除 Deleted'
      },

      ],
      tabspage: '',
      ordertype: 0,
      order_status: false,
      buy_status: false,
      sell_status: false,
      ordernum: '',
      neworderstatus: 0,
      sendmessage: false,
      sendmessage_component: ''
    };
  },
  watch: {
    '$route.query': {
      handler (newName, oldName) {
        let order_id = this.$route.query.id;
        this.order_id = order_id;
        this.loadpage();
        this.getdata();
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    saveStatus () {
      let status = this.neworderstatus;
      let id = this.orderinfo.id;
      let staff_id = sessionStorage.getItem('staff_id');
      let store_id = this.orderinfo.store_id;
      let warning_text = "確認修改訂單進度嗎？";
      if (status == 3) {
        warning_text += '注意：訂單狀態修改為Successful后，不能再進行修改！';
      }
      this.$confirm(warning_text, '詢問', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.loading = true;
        this.post("/api/order/edit_status", {
          status,
          id,
          staff_id,
          store_id,
        }).then(response => {
          this.loading = false;
          if (response.status == 'success') {
            this.$message({
              showClose: true,
              message: '修改成功！',
              type: 'success',
            });
            this.getdata();
          } else {
            this.$message({
              showClose: true,
              message: '修改失敗，請重試！',
              type: 'error',
              offset: 160
            });
          }
        }).catch(error => {
          this.loading = false;
          console.log(error)
        })
      }).catch(error => {
        console.log(error);
      })
    },
    closedialog () {
      this.sendmessage = false;
      this.sendmessage_component = '';

    },
    closesendmessage () {
      this.sendmessage = false;
      this.sendmessage_component = '';

    },
    opensendmessage () {
      this.sendmessage = true;
      this.sendmessage_component = sendmessage;
    },
    pageback () {
      this.$router.go(-1);
    },
    tableft () {
      if (this.ordertype == 0) {
        let num = this.transformnum - 1;
        if (num >= 0) {
          this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';

          this.transformnum = num;
        }
      } else if (this.ordertype == 1) {
        let num = this.transformnum - 1;
        if (num >= 0) {
          this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';

          this.transformnum = num;
        }
      }

    },
    tabright () {
      if (this.ordertype == 0) {
        let num = this.transformnum + 1;
        if (num < this.tabs1.length - 1) {
          this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';

          this.transformnum = num;
        }
      } else if (this.ordertype == 1) {
        let num = this.transformnum + 1;
        if (num < this.tabs2.length - 1) {
          this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';

          this.transformnum = num;
        }
      }
    },
    changetabs1 (index) {
      this.tabsindex = index;
      switch (index) {
        case 0:
          this.tabspage = 'orderinfo';
          break;
        case 1:
          this.tabspage = 'buybusienes';
          break;
        case 2:
          this.tabspage = 'sellbusienes';
          break;
        case 3:
          this.tabspage = 'customerinfo';
          break;
        case 4:
          this.tabspage = 'orderfiles';
          break;
        case 5:
          this.tabspage = 'orderreview';
          break;
        case 6:
          this.tabspage = 'orderprofit';
          break;
        case 7:
          this.tabspage = 'orderrecord';
          break;
        case 8:
          this.tabspage = 'orderprint';
          break;
      }

    },
    changetabs2 (index) {
      this.tabsindex = index;
      switch (index) {
        case 0:
          this.tabspage = 'orderinfo';
          break;
        case 1:
          this.tabspage = 'buybusienes';
          break;
        case 2:
          this.tabspage = 'sellbusienes';
          break;
        case 3:
          this.tabspage = 'customerinfo';
          break;
        case 4:
          this.tabspage = 'remitterinfo';
          break;
        case 5:
          this.tabspage = 'orderfiles';
          break;
        case 6:
          this.tabspage = 'orderreview';
          break;
        case 7:
          this.tabspage = 'orderprofit';
          break;
        case 8:
          this.tabspage = 'orderrecord';
          break;
        case 9:
          this.tabspage = 'orderprint';
          break;
      }

    },
    loadpage () {
      this.tabspage = 'orderinfo';
    },
    getdata () {
      this.post('/api/order/orderinfo', {
        order_id: this.order_id
      }).then((res) => {
        this.orderinfo = res;
        this.ordertype = res.ordertype;
        this.store_id = res.store_id;
        // console.log(res.ordertype)
        if (res.ordertype == 0) {
          this.ordernum = res.store_shortname + '-' + 'C' + res.ordernum;
        } else if (res.ordertype == 1) {
          this.ordernum = res.store_shortname + '-' + 'R' + res.ordernum;

        } else if (res.ordertype == 2) {
          this.ordernum = res.store_shortname + '-' + 'I' + res.ordernum;
        }
        this.neworderstatus = res.status;
        if (res.status == 3) {
          this.order_status = true;
        }
        if (res.buy.status == 3) {
          this.buy_status = true;
        }
        if (res.sell.status == 3) {
          this.sell_status = true;
        }
      }).catch((err) => {

        console.log(err)
      })
    }
  },
  computed: {
    editStatus () {
      if (this.order_status == false) {
        if (this.buy_status == true && this.sell_status == true) {
          return false;
        }
      }
      return true;
    },
  },
  mounted () {

    let order_id = this.$route.query.id;

    this.order_id = order_id;
    this.loadpage();
    this.getdata();
  }

};
</script>
<style scoped>
.orderbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}

.orderbox-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.orderbox-left > div {
  margin-right: 20px;
}

.changeorderstatus {
  display: flex;
  align-items: center;
}

.order-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mm-phone320 {
  display: flex;
}

.mr-10 {
  margin-right: 10px;
}

@media screen and (max-width: 1024px) {
  .orderbox {
    display: block;
  }

  .order-right {
    margin-top: 10px;
  }

  .mm-tabs-content {
    padding: 10px 5px;
  }
}

@media screen and (max-width: 320px) {
  .orderbox {
    display: block;
  }

  .order-right {
    margin-top: 10px;
  }

  .mm-tabs-content {
    padding: 10px 5px;
  }

  .mm-phone320 {
    display: block;
  }
}
</style>
